document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'productCategoriesCrop', ({ earlyStart = 0, startScale = 1.8, endScale = 1 } = {}) => ({

		ticking:    false,
		earlyStart,

		startScale,
		endScale,

		rate: 1,

		init() {
			const mql = window.matchMedia( '(max-width: 1023px)' );

			if ( mql.matches ) {
				return;
			}

			// Randomize rate (0.7 – 1.3) so each box settles at a slightly
			// different pace.
			this.rate = 0.7 + Math.random() * 0.6;

			this.onScroll = () => {
				if ( this.ticking ) {
					return;
				}

				this.ticking = true;

				window.requestAnimationFrame( () => {
					this.compute();
					this.ticking = false;
				});
			};

			window.addEventListener( 'scroll', this.onScroll, { passive: true });
			window.addEventListener( 'resize', this.onScroll, { passive: true });

			this.compute();

			mql.addEventListener( 'change', ( e ) => {
				if ( e.matches ) {
					window.removeEventListener( 'scroll', this.onScroll );
					window.removeEventListener( 'resize', this.onScroll );
					this.clearProps();
				} else {
					window.addEventListener( 'scroll', this.onScroll, { passive: true });
					window.addEventListener( 'resize', this.onScroll, { passive: true });
					this.compute();
				}
			});

			this.$cleanup = () => {
				window.removeEventListener( 'scroll', this.onScroll );
				window.removeEventListener( 'resize', this.onScroll );
			};
		},

		clearProps() {
			const figure = this.$el.querySelector( 'figure' );
			if ( ! figure ) {
				return;
			}

			const img = figure.querySelector( 'img' );
			if ( img ) {
				img.style.removeProperty( 'transform' );
			}
		},

		compute() {
			const figure = this.$el.querySelector( 'figure' );
			if ( ! figure ) {
				return;
			}

			// Key progress to the whole section, not just the card, so the
			// animation settles when the entire component has scrolled into view.
			const section = this.$el.closest( '.component--product-categories' ) || this.$el;
			const rect    = section.getBoundingClientRect();
			const vh      = window.innerHeight;
			const offset  = rect.height * this.earlyStart;

			// Progress runs 0 → 1 as the section travels from "top edge enters at
			// the bottom of the viewport" to "fully in view" (bottom edge meets
			// the viewport bottom) — a travel distance of one section height, so
			// it reaches its finished state the moment the section is completely
			// visible. earlyStart shortens that travel to finish sooner.
			const travel  = Math.max( 1, rect.height - offset );
			const raw     = ( vh - rect.top ) / travel;
			const clamped = Math.min( 1, Math.max( 0, raw ) );
			const eased   = 1 - Math.pow( 1 - clamped, 2 ); // ease-out quad

			// Start larger and shrink to fit the box. The image begins zoomed
			// in (startScale) so it overflows the frame, then settles toward
			// endScale (fills the box exactly) as the component scrolls in.
			// It never drops below endScale, so the image always backs the
			// overlay copy — no gray box shows through.
			const span  = ( this.startScale - this.endScale ) * this.rate;
			const scale = ( this.endScale + ( 1 - eased ) * span ).toFixed( 3 );

			const img = figure.querySelector( 'img' );
			if ( img ) {
				img.style.transform = `scale( ${scale} )`;
			}
		},

	}) );

});
